{
  "version": 1,
  "asset_id": "828d6627-2019-42ae-83af-f4b8773057d1",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/828d6627-2019-42ae-83af-f4b8773057d1/bypass-normal-boxed-en-796.webp",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/828d6627-2019-42ae-83af-f4b8773057d1/bypass-normal-boxed-en-796.webp",
  "original_filename": "bypass-normal-boxed-en-796.webp",
  "size": 24438,
  "content_type": "image/webp",
  "created_at": "2026-10-06T14:09:01Z"
}
